import ReducerBuilder from 'classes/ReducerBuilder';
import * as SectionReductions from 'utils/sectionManagement/reductions';
import {Types as SectionActions} from 'utils/sectionManagement/actions';
import editPrizeReducerInitialState from './initialState';
import {Types} from './actions';

export default ReducerBuilder.make(editPrizeReducerInitialState)
  .forType(Types.REQUEST_PRIZE)
  .reduce((state, action) => {
    state.currentPrizeId = action.prizeId;
    state.isRelatedPrize = action.isRelatedPrize;
  })
  .forType(Types.SET_CURRENT_PRIZE)
  .reduce((state, action) => {
    state.currentPrizeId = action.prizeId;
  })
  .forType(Types.RECEIVED_PRIZE)
  .reduce((state, action) => {
    state.isRelatedPrize = false;
  })
  .forType(Types.UNMOUNT_PRIZE)
  .reduce((state, action) => {
    state.currentPrizeId = null;
  })
  .forType(Types.PUBLISH_PRIZE_SUBMIT)
  .reduce((state, action) => {
    state.publishingPrize = true;
  })
  .forType(Types.PUBLISH_PRIZE_ERROR)
  .reduce((state, action) => {
    state.publishingPrize = false;
    state.prizeWasPublished = false;
    state.isPublishPrizeModalOpen = true;

    const {invalidReasons} = action.error;
    state.prizePublishErrors = Object.keys(invalidReasons).map(key => `editprize.publish.error.${key}.${invalidReasons[key]}`);
  })
  .forType(Types.PUBLISH_PRIZE_SUCCESS)
  .reduce((state, action) => {
    state.publishingPrize = false;
    state.prizeWasPublished = true;
    state.isPublishPrizeModalOpen = true;
  })

  .forType(Types.CLOSE_PUBLISH_PRIZE_MODAL)
  .reduce((state, action) => {
    state.prizePublishErrors = [];
    state.prizeWasPublished = null;
    state.isPublishPrizeModalOpen = false;
  })

  .forType(SectionActions.TOGGLE_SECTION_OPEN)
  .reduce(SectionReductions.toggleSectionOpen)

  .forType(SectionActions.REGISTER_SECTION)
  .reduce(SectionReductions.registerSection)

  .forType(SectionActions.UNREGISTER_SECTION)
  .reduce(SectionReductions.unregisterSection)

  .build();



// WEBPACK FOOTER //
// ./public/pages/EditPrize/reducer.js